/* eslint-disable no-param-reassign */

import { CaseReducer, SliceCaseReducers } from '@reduxjs/toolkit';
import { createSlice } from 'helpers/createSlice';
import { ApiStateData, MakerSelectors } from 'types';

interface State {
  contentIds: {
    detailsTripActionInRow: Array<string>;
    interestedProvidersRefresh: Array<string>;
    mapLocationsNewEdit: Array<string>;
  };
}

interface Reducers extends SliceCaseReducers<State> {
  reset: CaseReducer<State>;
}

interface ExtraSelectors extends MakerSelectors<ApiStateData<State>> {
  getHasDetailsTripActionInRow: (d: ApiStateData<State>) => (id: string) => boolean;
  getHasInterestedProvidersRefreshIds: (d: ApiStateData<State>) => (id: string) => boolean;
  getHasButonRefreshTopAction: (d: ApiStateData<State>) => (id: string) => boolean;
  getMapLocationsNewEdit: (d: ApiStateData<State>) => (id: string) => boolean;
}

const initialState: State = {
  contentIds: {
    /**
     * Call detailsTrip row action when click in row
     */
    detailsTripActionInRow: [
      '62f07e54c2f2122fb3dfc199',
      '62f07f0cc2f2122fb3dfc19b',
      '62f07ed1c2f2122fb3dfc19a',
      '62f07f34c2f2122fb3dfc19c',
      '62f07f59c2f2122fb3dfc19d',
      '62eca7616555a8f79484667d',
      '62eca80f6555a8f79484667e',
      '62eca8ab6555a8f794846680',
      '62eca8566555a8f79484667f',
      '62ecaa726555a8f794846681',
      '62b4ca8fe546ad890e2e45e6',
      '62eca1506555a8f794846678',
      '62eca28a6555a8f794846679',
      '62eca60c6555a8f79484667b',
      '62eca5046555a8f79484667a',
      '62eca6556555a8f79484667c',
      '62eca1506555a8f794846679',
    ],
    /**
     * auto refresh the table of interested providers
     * Path: <Con Terceros - Medios Propios / Acción Detalles en todas las tablas de esas dos secciones>
     */
    /* Botón de refrescar en la topAction de la tabla Transportistas Interesados
    Path: <Con Terceros - Medios Propios / Acción Detalles / Tabla Transportistas Interesados> */
    interestedProvidersRefresh: ['62e20b62f99553a17d8858e9'],

    mapLocationsNewEdit: ['621f982f2d0d1e238eb95d7c'],
  },
};

export const dynamicTables = createSlice<State, Reducers, ExtraSelectors>({
  name: 'dynamicTables',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraSelectors: {
    getHasDetailsTripActionInRow: (data) => (id) =>
      data?.contentIds.detailsTripActionInRow.includes(id) || false,
    getHasInterestedProvidersRefreshIds: (data) => (id) =>
      data?.contentIds.interestedProvidersRefresh.includes(id) || false,
    getHasButonRefreshTopAction: (data) => (id) =>
      data?.contentIds.interestedProvidersRefresh.includes(id) || false,
    getMapLocationsNewEdit: (data) => (id) =>
      data?.contentIds.mapLocationsNewEdit.includes(id) || false,
  },
});
